module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-hp__wrapper"
  }, [_c('div', {
    ref: "parent",
    staticClass: "cb-header cb-transition__slide",
    attrs: {
      "id": "cb-header"
    }
  }, [_c(_vm.headerType, {
    directives: [{
      name: "cb-slide",
      rawName: "v-cb-slide",
      value: ({
        isnew: _vm.isNewHeader,
        ref: _vm.$refs.parent
      }),
      expression: "{ isnew : isNewHeader , ref: $refs.parent }"
    }],
    tag: "component"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cb-body",
    attrs: {
      "id": "cb-body",
      "role": "main"
    }
  }, [_c('transition', {
    attrs: {
      "name": "scale-down-y"
    }
  }, [(_vm.showNotification) ? _c('cb-modal', {
    attrs: {
      "icon": _vm.current_notification.type,
      "show-icon": _vm.current_notification.showIcon,
      "text": _vm.current_notification.message,
      "is-dismissible": _vm.current_notification.isDismissible
    },
    on: {
      "clearModalDialog": function($event) {
        _vm.showNotification = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showLoader) ? _c('cb-loader') : _vm._e(), _vm._v(" "), (_vm.portal_loaded) ? [(_vm.allowed) ? _c('router-view', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (_vm.canAnimate()),
      expression: "canAnimate()"
    }]
  }) : _c('div', {
    staticClass: "cb-body__wrap"
  }, [_vm._v("\n          " + _vm._s(_vm.st('not_allowed')) + "\n        ")])] : _c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('portal-loader')], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1692b7e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/CustomerPortal.vue
// module id = 579
// module chunks = 66